/**
 * Asynchronously loads the component for NotFoundPage
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./Claim'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/FindTheLink/ClaimLoadable.js